import PubSub from '@/pubsub'

const KEY_ACCESS_TOKEN = 'access-token'
const KEY_USER_DETAIL = 'user'
const KEY_COMPANY_DETAIL = 'company'
const KEY_COMPANY_LIST_DETAIL = 'company-list'
const KEY_AGENT_LIST_DETAIL = 'agent-list'
const KEY_AGENT_LIST_VERSION = 'agent-list-version'
const KEY_HOTEL_DETAIL = 'hotel'

const mockLocalStorage = {
  getItem: () => {},
  setItem: () => {},
  clear: () => {}
}

const storage = (process.env.NODE_ENV === 'test') ? mockLocalStorage : localStorage

const _getAndParseJsonByKey = (key) => {
  try {
    const jsonString = storage.getItem(key)

    if (jsonString === null && key === 'hotel') {
      return undefined
    }

    if (jsonString === null) {
      PubSub.publish(PubSub.EVENT.UNAUTHORIZED)
      return undefined
    }

    return JSON.parse(jsonString)
  } catch (e) {
    return undefined
  }
}

const getToken = () => {
  const token = storage.getItem(KEY_ACCESS_TOKEN)

  if (!token) {
    return PubSub.publish(PubSub.EVENT.UNAUTHORIZED)
  }

  return token
}

const setToken = (token) => {
  storage.setItem(KEY_ACCESS_TOKEN, token)
}

const getUserDetail = () => {
  return _getAndParseJsonByKey(KEY_USER_DETAIL)
}

const setUserDetail = (userDetail) => {
  storage.setItem(KEY_USER_DETAIL, JSON.stringify(userDetail))
}

const getCompanyDetail = () => {
  return _getAndParseJsonByKey(KEY_COMPANY_DETAIL)
}

const setCompanyDetail = (companyDetail) => {
  storage.setItem(KEY_COMPANY_DETAIL, JSON.stringify(companyDetail))
}

const getCompanyList = () => {
  return _getAndParseJsonByKey(KEY_COMPANY_LIST_DETAIL)
}

const setHotelDetail = (hotelDetail) => {
  storage.setItem(KEY_HOTEL_DETAIL, JSON.stringify(hotelDetail))
}

const getHotelDetail = () => {
  return _getAndParseJsonByKey(KEY_HOTEL_DETAIL)
}

const setCompanyList = (companyList) => {
  storage.setItem(KEY_COMPANY_LIST_DETAIL, JSON.stringify(companyList))
}

const getAgentList = () => {
  return _getAndParseJsonByKey(KEY_AGENT_LIST_DETAIL)
}

const setAgentList = (agentList) => {
  storage.setItem(KEY_AGENT_LIST_DETAIL, JSON.stringify(agentList))
}

const getAgentListCacheVersion = () => {
  const version = storage.getItem(KEY_AGENT_LIST_VERSION)
  return version
}

const setAgentListCacheVersion = (cacheVersion) => {
  storage.setItem(KEY_AGENT_LIST_VERSION, cacheVersion)
}

const clear = () => {
  storage.clear()
}

export default {
  clear,
  getToken,
  setToken,
  getUserDetail,
  setUserDetail,
  getCompanyDetail,
  setHotelDetail,
  setCompanyDetail,
  getCompanyList,
  getHotelDetail,
  setCompanyList,
  getAgentList,
  setAgentList,
  getAgentListCacheVersion,
  setAgentListCacheVersion
}
